const checkMultislideSwatches = () => {
  document
    .querySelectorAll(".js-multislide-swatches-wrapper")
    .forEach((wrapper) => {
      const swatches = wrapper.querySelectorAll(".js-multislide-swatch");
      const image = wrapper.querySelector("img.multislide_product_image");
      const link = wrapper.querySelector(".js-multislide-swatches-link");
      const price = wrapper.querySelector(".feat_coll_price");

      if (!swatches.length || !image || !link) return;

      swatches.forEach((swatch) => {
        swatch.addEventListener("click", (event) => {
          event.preventDefault();
          const nextSrc = swatch.dataset.imageSrc;
          const nextSrcset = swatch.dataset.imageSrcset;
          const nextAlt = swatch.dataset.imageAlt;
          const nextUrl = swatch.dataset.variantUrl;
          const nextPriceHtml = swatch.dataset.priceHtml;
          const nextPrice = swatch.dataset.price;
          const nextCompareText = swatch.dataset.compareText;
          const hasDiscount = swatch.dataset.hasDiscount === "true";

          if (nextUrl) {
            link.setAttribute("href", nextUrl);
          }

          if (price) {
            const priceEl = price.querySelector(".price");
            let discountedEl = price.querySelector(".price_discounted");

            if (priceEl && nextPrice) {
              priceEl.textContent = nextPrice;
              if (hasDiscount) {
                priceEl.classList.add("discount");
              } else {
                priceEl.classList.remove("discount");
              }
            } else if (nextPriceHtml) {
              price.innerHTML = nextPriceHtml;
              discountedEl = price.querySelector(".price_discounted");
            }

            if (hasDiscount) {
              if (!discountedEl) {
                discountedEl = document.createElement("span");
                discountedEl.className = "price_discounted";
                price.appendChild(discountedEl);
              }
              if (nextCompareText) {
                discountedEl.textContent = nextCompareText;
              }
              discountedEl.style.display = "";
            } else if (discountedEl) {
              discountedEl.style.display = "none";
            }
          }

          if (nextSrc) {
            if (image.getAttribute("src") !== nextSrc) {
              image.setAttribute("src", nextSrc);
            }
            if (nextSrcset) {
              image.setAttribute("srcset", nextSrcset);
            }
            if (nextAlt) {
              image.setAttribute("alt", nextAlt);
            }
          }

          swatches.forEach((item) => item.classList.remove("is-active"));
          swatch.classList.add("is-active");
        });
      });
    });
};

const initMultislideSwatches = () => {
  checkMultislideSwatches();

  document.addEventListener("shopify:section:load", function () {
    checkMultislideSwatches();
  });
};

(function () {
  initMultislideSwatches();
})();
